import HTTPRequest from '../index'

const apiPath = '/api/v2/users/user-treatments'
import { FormValues } from 'src/containers/MedicalSpecialty/components/useMedicalSpecialtyForm'

class UserTreatment extends HTTPRequest {
  index(params) {
    return this.get(`${apiPath}`, { params })
  }

  create(value: FormValues) {
    return this.post(`${apiPath}`, { ...value })
  }

  show(id, params) {
    return this.get(`${apiPath}/${id}`, { params })
  }

  update(id, data) {
    return this.patch(`${apiPath}/${id}`, data)
  }

  cancel(id) {
    return this.delete(`${apiPath}/${id}`)
  }

  checkExists(data: { menu_id: string | number }) {
    return this.post(`${apiPath}/exists`, data)
  }

  updatePlanSelection(
    id: string | number,
    data: { has_selected_plan: boolean; plan_id?: number | string | null },
  ) {
    return this.put(`${apiPath}/${id}/update-state`, data)
  }

  updateCallState(id, state) {
    return this.put(`${apiPath}/${id}/update-call-state`, { state })
  }
}

export default new UserTreatment()
